export const MinimumGiftValue = 150;
export const ExecutiveGiftValue = 300;


// WEBPACK FOOTER //
// ./app/constants/giftValue.js